import { render, staticRenderFns } from "./RsaConfigurazioneAttivitaListPage.vue?vue&type=template&id=9f2e0a58"
import script from "./RsaConfigurazioneAttivitaListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAttivitaListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports